export { default } from "./infoCardField";
